import { trpc } from "@/trpc";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Users } from "lucide-react";
import { EventType } from "@satyrsmc/shared/lib/enums";
import { RideAttendeesCard } from "@/components/events/RideAttendeesCard";
import { findUpcomingEvent } from "@/lib/eventUtils";

/** Admin-dashboard widget: reuses the exact same attendees card shown on an
 * event's own detail page (RideAttendeesCard), for whichever Badger event is
 * upcoming — published (not draft), not cancelled, not yet ended, with a
 * real date to be "upcoming" by. */
export function BadgerAttendeesChartCard() {
  const { data: events, isLoading: isLoadingList } = trpc.admin.events.list.useQuery({
    type: EventType.Badger,
  });

  const upcoming = findUpcomingEvent(events ?? []);

  const { data: event, isLoading: isLoadingEvent } = trpc.admin.events.get.useQuery(
    { id: upcoming?.id ?? "" },
    { enabled: !!upcoming },
  );

  if (isLoadingList || (upcoming && isLoadingEvent)) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Users className="size-5" />
            Badger Attendees
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="h-40 animate-pulse rounded bg-muted" />
        </CardContent>
      </Card>
    );
  }

  if (!upcoming || !event) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Users className="size-5" />
            Badger Attendees
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">No upcoming Badger events.</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <RideAttendeesCard
      eventId={event.id}
      attendees={event.event_attendees ?? []}
      title={`${event.name} Attendees`}
    />
  );
}
